import { Services } from "slotworks/services/services";

class Currency {

    /**
     * DEPRECATED. Use Services.currency instead
     */
    public get symbolDisplay() {
        return Services.currency.symbolDisplay;
    }

    /**
     * DEPRECATED. Use Services.currency instead
     */
    public set symbolDisplay(value) {
        Services.currency.symbolDisplay = value;
    }

    /**
     * DEPRECATED. Use Services.currency instead
     */
    public get credits() {
        return Services.currency.credits;
    }

    /**
     * DEPRECATED. Use Services.currency instead
     */
    public set credits(value) {
        Services.currency.credits = value;
    }

    /**
     * DEPRECATED. Use Services.currency instead
     */
    public get creditRatio() {
        return Services.currency.creditRatio;
    }

    /**
     * DEPRECATED. Use Services.currency instead
     */
    public set creditRatio(value) {
        Services.currency.creditRatio = value;
    }

    /**
     * DEPRECATED. Use Services.currency instead
     */
    public configure(locale: string, currency: string, symbolDisplay: "symbol" | "code", credits: boolean = null, creditRatio: number = 1, useGrouping: boolean = true) {
        Services.currency.configure(locale, currency, symbolDisplay, credits, creditRatio, useGrouping);
    }

    /**
     * DEPRECATED. Use Services.currency instead
     */
    public format(value: number, trailingDecimals: boolean = true, forceCreditMode?: boolean): string {
        return Services.currency.format(value, trailingDecimals, forceCreditMode);
    }

    /**
     * DEPRECATED. Use Services.currency instead
     */
    public fixFloatingPointError(s: string) {
        return Services.currency.fixFloatingPointError(s);
    }
}

export default new Currency();
